import { useMutation } from "@tanstack/react-query";
import { submitBioLead } from "@/services/bioLeadService";

export const useBioLeadForm = (slug, options = {}) =>
  useMutation({
    mutationFn: (body) => submitBioLead(slug, body),
    ...options,
  });
